<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isActive"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <div class="flex items-center">
        <img width="40" :src="ProductIcon" class="mr-4" />
        <div>
          <h4>Stock product request</h4>
          <small v-if="product">{{ product.name }}</small>
        </div>
      </div>
      <feather-icon
        icon="XIcon"
        @click.stop="isActive = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <Loading v-if="isLoading" />
      <div v-else class="p-6">
        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Name</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="product.name" />
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Country</span>
          </div>
          <div>
            <vs-select v-model="product.countryId" class="w-4/5" autocomplete>
              <vs-select-item
                :key="index"
                :value="item.countryId.id"
                :text="item.name"
                v-for="(item, index) in countries"
              />
            </vs-select>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Category</span>
          </div>
          <div class="flex">
            <vs-select
              v-model="product.productCategoryId"
              class="w-4/5"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item.productCategoryId.id"
                :text="item.name"
                v-for="(item, index) in productCategories"
              />
            </vs-select>
            <!-- <feather-icon class="ml-4" icon="FolderIcon" svgClasses="w-4 h-4" /> -->
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Vendor</span>
          </div>
          <div class="flex">
            <vs-select v-model="product.vendorId" class="w-4/5" autocomplete>
              <vs-select-item
                :key="index"
                :value="item.vendorId.id"
                :text="item.name"
                v-for="(item, index) in vendors"
              />
            </vs-select>
            <!-- <feather-icon class="ml-4" icon="MapIcon" svgClasses="w-4 h-4" /> -->
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Alternative vendor(s)</span>
          </div>
          <div class="flex">
            <vs-select
              v-model="product.alternativeVendorIds"
              multiple
              class="w-4/5"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item.vendorId.id"
                :text="item.name"
                v-for="(item, index) in vendors"
              />
            </vs-select>
            <!-- <feather-icon class="ml-4" icon="MapIcon" svgClasses="w-4 h-4" /> -->
          </div>
        </div>

        <!-- Pricing </vs-divider> -->

        <vs-row>
          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Unit price</span>
            </div>
            <div>
              <div class="flex">
                <vs-input-number v-model="product.unitPrice" :step="0.05" />
              </div>
            </div>
          </vs-col>

          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Case size</span>
            </div>
            <div>
              <div class="flex">
                <vs-input-number v-model="product.caseSize" :step="1" />
              </div>
            </div>
          </vs-col>
        </vs-row>

        <vs-divider class="mt-6" />

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Product link</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="product.productLink" />
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Comment</span>
          </div>
          <div>
            <vs-textarea class="w-full" v-model="product.requesterComment" />
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{
        "Submit"
      }}</vs-button>
      <vs-button type="border" color="danger" @click="isActive = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/product-icon.png";
import { mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      product: null,

      countries: [
        // TODO Should come from backend
        {
          countryId: {
            id: "dk",
          },
          name: "Denmark",
          code: "DK",
        },
        {
          countryId: {
            id: "no",
          },
          name: "Norway",
          code: "NO",
        },
        {
          countryId: {
            id: "fi",
          },
          name: "Finland",
          code: "FI",
        },
        {
          countryId: {
            id: "uk",
          },
          name: "United Kingdom",
          code: "UK",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      vendors: "vendors/vendors",
      productCategories: "productCategories/productCategories",
    }),
    isFormValid() {
      if (!this.product) return false;
      return this.product.name && this.product.productCategoryId;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    async showEmptyProduct() {
      this.isNewProduct = true;

      // Try to fetch country from active venue
      const venueTags = this.$store.getters["venues/activeVenue"];
      let countryTag = venueTags.tags.find((x) => x.startsWith("country:"));
      countryTag = countryTag ? countryTag.split(":")[1] : "";

      this.product = {
        name: "",
        vendorId: "",
        alternativeVendorIds: [],
        productCategoryId: "",
        countryId: countryTag,
        caseSize: 0,
        unitPrice: 10,
        requesterComment: "",
        productLink: "",
      };

      this.isActive = true;
      await this.loadExternalData();
      this.isLoading = false;
    },

    async loadExternalData() {
      await this.$store.dispatch("vendors/getVendors");
      await this.$store.dispatch("productCategories/getProductCategories");
    },

    async submitData() {
      console.log("Submitting DTO", this.product);

      var result = await this.$store.dispatch(
        "stockProductRequests/create",
        this.product
      );

      if (result) {
        this.$vs.notify({
          title: "Request submitted",
          text: "Your stock product request has been submitted.",
        });
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Failed to submit stock product request",
        });
      }

      this.product = null;
      this.isActive = false;
      this.isLoading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>